module.exports = __webpack_public_path__ + "img/bg5.bcec103f.png";